import { Box } from '@material-ui/core'
import { useTheme } from 'styled-components'

export interface IRequiredSignProps {
  /** Useful for when this element increases the height of your label. You can hide it so that the label keeps it's shape */
  visible?: boolean
}

export const RequiredSign = ({ visible }: IRequiredSignProps) => {
  const theme = useTheme()
  return (
    <>
      <Box color={theme.colors.error} visibility={visible ? '' : 'hidden'} component="span">
        <sup>*</sup>
      </Box>
    </>
  )
}
